import {config} from '../config';

export default {
    getSupportedImageTypes: () => config.data.upload.supportedImageTypes,
};
